import { AuthenticationUser, AuthRoleEnum } from '@codezo/graphql';
import { Route, Routes } from 'react-router-dom';
import { AuthCallbackPage } from './AuthCallbackPage';
import { LogoutCallback } from './LogoutCallback';
import { ReAuthenticateCallback } from './ReAuthenticateCallback';

type AuthRoutesProps<TUser> = {
	setUser: (_user: TUser | null) => void;
	setAccessToken: (_token: string | null) => void;
	userFormatter: (_user: AuthenticationUser) => TUser;
	token: string | null;
	requiredRole: AuthRoleEnum;
};

export const AuthRoutes = <TUser,>({
	setUser,
	setAccessToken,
	userFormatter,
	token,
	requiredRole,
}: AuthRoutesProps<TUser>) => {
	return (
		<Routes>
			<Route
				path="/auth/callback"
				element={
					<AuthCallbackPage
						requiredRole={requiredRole}
						successRedirect="/dashboard"
						setUser={(user) => setUser(userFormatter(user))}
						setAccessToken={setAccessToken}
					/>
				}
			/>
			<Route
				path="/auth/reauth"
				element={
					<ReAuthenticateCallback
						setUser={(user) => setUser(userFormatter(user))}
						setAccessToken={setAccessToken}
					/>
				}
			/>
			<Route
				path="/auth/logout"
				element={
					<LogoutCallback
						setUser={() => setUser(null)}
						setAccessToken={setAccessToken}
						token={token}
					/>
				}
			/>
		</Routes>
	);
};
